import { useQuery } from '@tanstack/react-query';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { searchPlaces } from '../../api/geocode';
import { useDebounce } from '../../hooks/useDebounce';

const MapAreaSearch = ({ onSelect, className = '' }) => {
  const { t } = useTranslation();
  const [input, setInput] = useState('');
  const [open, setOpen] = useState(false);
  const debounced = useDebounce(input, 450);

  const { data, isFetching } = useQuery({
    queryKey: ['map-area-search', debounced],
    queryFn: () => searchPlaces(debounced),
    enabled: open && debounced.trim().length >= 2,
    staleTime: 60_000,
  });

  const results = data?.results || [];

  const pick = (place) => {
    setInput(place.label);
    setOpen(false);
    onSelect?.({ lat: place.latitude, lng: place.longitude, label: place.label });
  };

  return (
    <div className={`relative min-w-0 w-full flex-1 sm:min-w-[220px] ${className}`}>
      <label className="mb-1 block text-xs text-zinc-500">{t('explore.searchArea')}</label>
      <input
        type="text"
        value={input}
        onChange={(e) => {
          setInput(e.target.value);
          setOpen(true);
        }}
        onFocus={() => setOpen(true)}
        onBlur={() => window.setTimeout(() => setOpen(false), 150)}
        placeholder={t('explore.searchAreaPlaceholder')}
        className="w-full rounded-lg border border-zinc-300 bg-zinc-50 px-3 py-2 text-sm outline-none focus:border-glow-500 dark:border-zinc-700 dark:bg-zinc-950"
      />
      {isFetching && (
        <span className="absolute right-3 top-8 text-xs text-zinc-500">{t('common.working')}</span>
      )}
      {open && results.length > 0 && (
        <ul className="absolute z-20 mt-1 max-h-52 w-full overflow-y-auto rounded-lg border border-zinc-300 bg-white shadow-lg dark:border-zinc-700 dark:bg-zinc-900">
          {results.map((place) => (
            <li key={`${place.latitude}-${place.longitude}-${place.label}`}>
              <button
                type="button"
                onMouseDown={(e) => e.preventDefault()}
                onClick={() => pick(place)}
                className="w-full px-3 py-2 text-left text-sm hover:bg-zinc-100 dark:hover:bg-zinc-800"
              >
                {place.label}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MapAreaSearch;
